import { trpc } from '@tencent/tpro_rmonitor_manage_server_quality_report';
import { BusiCode } from '@/infrastructure/axios/code';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

export type ISetWeightConfigReq = WithTypeCast<trpc.rmonitor.manage_server.ISetWeightConfigReq>;
export type ISetWeightConfigRsp = WithTypeCast<trpc.rmonitor.manage_server.ISetWeightConfigRsp>;
export type IGetWeightConfigReq = WithTypeCast<trpc.rmonitor.manage_server.IGetWeightConfigReq>;
export type IGetWeightConfigRsp = WithTypeCast<trpc.rmonitor.manage_server.IGetWeightConfigRsp>;
export type IWeightConfig = WithTypeCast<trpc.rmonitor.manage_server.IWeightConfig>;
export type MetricType = trpc.rmonitor.metrics_server.MetricType;
export const { MetricType } = trpc.rmonitor.metrics_server;

export class QualityReportService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.QualityReportService,
    });
  }

  /**
   * 设置权重
   * @param req
   */
  public async setWeightConfig(req: ISetWeightConfigReq): Promise<boolean> {
    try {
      const res = await this.trpcPost<ISetWeightConfigRsp>('SetWeightConfig', req);
      return res.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      return false;
    }
  }

  /**
   * 查询权重
   * @param req
   */
  public async getWeightConfig(req: IGetWeightConfigReq): Promise<IGetWeightConfigRsp> {
    try {
      return await this.trpcPost<IGetWeightConfigRsp>('GetWeightConfig', req);
    } catch (e) {
      return {};
    }
  }
}

export const qualityReportService = new QualityReportService();
